import { createContext, ReactNode, useState } from "react";

const defaultBillingUploadProps: IBillingUploadContextType= {
  handleChangeStatus: (status: ProgressStatus) => {},
  saveUserFormData: (formData: IBillingUploadForm) => {},
  stepStatus: "blocked",
  userFormData: undefined
}

export const BillingUploadContext = createContext<IBillingUploadContextType>(defaultBillingUploadProps);

const BillingUploadProvider = (props : IBillingUploadProviderProps) => {
  const [stepStatus, setStepStatus] = useState<ProgressStatus>("blocked");
  const [userFormData, setUserForm] = useState<IBillingUploadForm | undefined>(undefined);

  const handleChangeStatus = (status: ProgressStatus) => {
    setStepStatus(status);
  }

  const saveUserFormData = (formData: IBillingUploadForm | undefined) => {
    setUserForm(formData);
  }

  const providerValue = {
    handleChangeStatus,
    saveUserFormData,
    stepStatus,
    userFormData
  }

  return (
    <BillingUploadContext.Provider value={providerValue}>
        {props.children}
    </BillingUploadContext.Provider>
  )
}

interface IBillingUploadContextType {
  handleChangeStatus: (status: ProgressStatus) => void,
  saveUserFormData: (formData: IBillingUploadForm) => void,
  stepStatus: ProgressStatus,
  userFormData: IBillingUploadForm | undefined;
}

interface IBillingUploadProviderProps {
  children: ReactNode;
}

export default BillingUploadProvider;
